import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import AnimatedArcs from '../../common/AnimatedArcs';
import HubSpotEmbedForm, { IHubSpotEmbedFormProps } from '../HubSpotEmbedForm';

export interface IContactCTAHubSpotProps extends IBaseElementProps {
	backgroundImage?: IImage;
	title?: string;
	description?: string;
	enableLineAnimations?: boolean;
	centreForm?: boolean;
	colourThemes?: 'default' | 'inverted' | 'white' | 'grey';
	hubSpotForm?: IHubSpotEmbedFormProps;
	roundedCorners?: boolean;
}

/**
 * Calian Contact CTA
 * @icon welcome-widgets-menus
 * @block
 */
const ContactCTAHubSpot: React.FC<IContactCTAHubSpotProps> = ({
	id,
	className,
	classNames = [],
	backgroundImage,
	title,
	description,
	enableLineAnimations = true,
	centreForm = false,
	colourThemes = 'default',
	hubSpotForm,
	roundedCorners = false,
}) => {
	return (
		<div
			id={id}
			className={
				className ||
				cn(
					'calian-contact-cta overflow-hidden position-relative',
					colourThemes,
					roundedCorners && 'rounded-corners',
					...classNames,
				)
			}
		>
			<div className="calian-contact-cta__overlay position-absolute z-2"></div>
			{backgroundImage?.src && (
				<Image
					{...backgroundImage}
					className="calian-contact-cta__background-image position-absolute z-1"
				/>
			)}
			<div className="calian-contact-cta__container mx-auto py-5 py-md-10 position-relative z-3">
				<div className="d-flex">
					{hubSpotForm && (
						<div
							className={cn(
								'calian-contact-cta__form mx-auto px-3',
								!centreForm && 'me-lg-0',
							)}
						>
							{title && <h2>{title}</h2>}
							{description && (
								<p
									dangerouslySetInnerHTML={{
										__html: description,
									}}
								/>
							)}
							<HubSpotEmbedForm {...hubSpotForm} />
						</div>
					)}
				</div>
			</div>
			{enableLineAnimations && (
				<AnimatedArcs
					arcsStyle={'Component - Two Lines'}
					arcsPosition={'Left'}
					arcOneColor={'var(--bs-white)'}
					arcOneStrokeWidth={4}
					arcTwoColor={'var(--bs-primary)'}
					arcTwoStrokeWidth={3}
					animationDelay={250}
					animationOffset={150}
				/>
			)}
		</div>
	);
};
export default ContactCTAHubSpot;
